import "./DealWorkflows.css";

import { WorkflowTemplatePanel } from "../../../../../templates";
import { RelatedDealsPanel, WorkflowDataCards } from "../../../../shared/workflows/workflow-templates/components";
import { WorkflowTemplateTypeConstants } from "../constants";
import { useDealWorkflows } from "./useDealWorkflows";

const DealWorkflows = (): JSX.Element => {
  const {
    onPrevious,
    onNext,
    hasNext,
    hasPrevious,
    workflowTemplates,
    isLoadingWorkflowTemplates,
    relatedProjectWorkflowTemplateUuid,
    showCreateWorkflowTemplatePanel,
    setShowCreateWorkflowTemplatePanel,
    isExpiredFilter,
    setIsExpiredFilter,
    setRefreshWorkflowTemplates,
    projectTypesSelectData,
  } = useDealWorkflows();

  return (
    <div className="DealWorkflows">
      <WorkflowDataCards
        header="Available workflow templates"
        data={workflowTemplates}
        setShowCreateWorkflowTemplatePanel={setShowCreateWorkflowTemplatePanel}
        onPrevious={onPrevious}
        onNext={onNext}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        isLoadingWorkflowTemplates={isLoadingWorkflowTemplates}
        workflowTemplateUuid={relatedProjectWorkflowTemplateUuid}
        isExpiredFilter={isExpiredFilter}
        setIsExpiredFilter={setIsExpiredFilter}
        isProject={false}
      />
      <RelatedDealsPanel workflowTemplateUuid={relatedProjectWorkflowTemplateUuid} />
      <WorkflowTemplatePanel
        workflowTemplateType={WorkflowTemplateTypeConstants.DEAL}
        projectTypesSelectData={projectTypesSelectData}
        show={showCreateWorkflowTemplatePanel}
        onClose={() => setShowCreateWorkflowTemplatePanel(false)}
        setRefresh={setRefreshWorkflowTemplates}
      />
    </div>
  );
};

export default DealWorkflows;
